import { render, staticRenderFns } from "./SelectClientOrderStatus.vue?vue&type=template&id=2b5f7da4&scoped=true&"
import script from "./SelectClientOrderStatus.vue?vue&type=script&lang=js&"
export * from "./SelectClientOrderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f7da4",
  null
  
)

export default component.exports